<div class="drawer is-active">
  <div class="drawer-content">
    <div class="card">
      <div class="card-content">
        <div class="page-header">
          <h4
            [translationEditableDirective]="
              isEditable
                ? isCreate
                  ? 'CREATE_BUILDING'
                  : 'EDIT_BUILDING'
                : 'BUILDING_DETAILS'
            "
          >
            {{
              (isEditable
                ? isCreate
                  ? 'CREATE_BUILDING'
                  : 'EDIT_BUILDING'
                : 'BUILDING_DETAILS'
              ) | translate
            }}
          </h4>
        </div>

        <form
          [formGroup]="form"
          autocomplete="off"
          class="form mb-0"
          (submit)="onSubmit($event)"
        >
          <div class="form-fields">
            <div class="field is-narrow">
              <label class="label" translationEditableDirective="ID">{{
                'ID' | translate
              }}</label>
              <div class="control">
                <span>{{ form.get('id').value || '-' }}</span>
              </div>
            </div>

            <div class="field is-narrow">
              <label class="label" translationEditableDirective="PROPERTY">{{
                'PROPERTY' | translate
              }}</label>
              <div class="control">
                <span *ngIf="!form.get('propertyCode').value">{{
                  form.get('propertyCode').value || '-'
                }}</span>
                <a
                  *ngIf="form.get('propertyCode').value"
                  [routerLink]="['/properties', form.get('propertyId').value]"
                  >{{ form.get('propertyCode').value }}</a
                >
              </div>
            </div>

            <div class="field is-narrow">
              <label class="label" translationEditableDirective="NAME">{{
                'NAME' | translate
              }}</label>
              <div class="control">
                <span *ngIf="!isEditable">{{
                  form.get('name').value || '-'
                }}</span>
                <input
                  *ngIf="isEditable"
                  class="input"
                  type="text"
                  formControlName="name"
                  [ngClass]="{ 'is-danger': hasError('name') }"
                />
              </div>
              <p class="help is-danger" *ngIf="hasError('name')">
                {{ getError('name') }}
              </p>
            </div>

            <div class="field is-narrow">
              <label
                class="label"
                translationEditableDirective="NUMBER_OF_STORIES"
                >{{ 'NUMBER_OF_STORIES' | translate }}</label
              >
              <div class="control">
                <span *ngIf="!isEditable">{{
                  form.get('numberOfStories').value || '-'
                }}</span>
                <number-input
                  *ngIf="isEditable"
                  formControlName="numberOfStories"
                  [inputClass]="{
                    'is-danger': hasError('numberOfStories'),
                    input: true,
                  }"
                />
              </div>
              <p class="help is-danger" *ngIf="hasError('numberOfStories')">
                {{ getError('numberOfStories') }}
              </p>
            </div>

            <div class="field is-narrow">
              <label class="label" translationEditableDirective="AREA">{{
                'AREA' | translate
              }}</label>
              <div class="control has-icons-right">
                <span *ngIf="!isEditable"
                  >{{ form.get('area').value || '-' }}
                  {{ settings.SETTINGS_UNITS_AREA_SYMBOL }}</span
                >
                <number-input
                  *ngIf="isEditable"
                  formControlName="area"
                  [inputClass]="{ 'is-danger': hasError('area'), input: true }"
                />
                <span
                  *ngIf="isEditable"
                  class="icon is-small is-right"
                  style="color: black"
                >
                  {{ settings.SETTINGS_UNITS_AREA_SYMBOL }}
                </span>
              </div>
              <p class="help is-danger" *ngIf="hasError('area')">
                {{ getError('area') }}
              </p>
            </div>

            <div class="field is-narrow">
              <label class="label" translationEditableDirective="STREET">{{
                'STREET' | translate
              }}</label>
              <div class="control">
                <span *ngIf="!isEditable">{{
                  form.get('street').value ? form.get('street').value.name : '-'
                }}</span>
                <ng-select
                  *ngIf="isEditable"
                  [items]="streets"
                  formControlName="street"
                  [multiple]="false"
                  [closeOnSelect]="true"
                  [ngClass]="{ 'is-danger': hasError('street') }"
                  bindLabel="name"
                  [typeahead]="onStreetsAutocomplete$"
                >
                </ng-select>
              </div>
              <p class="help is-danger" *ngIf="hasError('street')">
                {{ getError('street') }}
              </p>
            </div>

            <div class="field is-narrow">
              <label
                class="label"
                translationEditableDirective="STREET_OTHER"
                >{{ 'STREET_OTHER' | translate }}</label
              >
              <div class="control">
                <input
                  *ngIf="isEditable"
                  class="input"
                  formControlName="streetOther"
                  type="text"
                  [ngClass]="{ 'is-danger': hasError('streetOther') }"
                />
                <span *ngIf="!isEditable">{{
                  getField(['streetOther']) || '-'
                }}</span>
              </div>
              <p class="help is-danger" *ngIf="hasError('streetOther')">
                {{ getError('streetOther') }}
              </p>
            </div>

            <div class="field is-narrow">
              <label
                class="label"
                translationEditableDirective="STREET_NUMBER"
                >{{ 'STREET_NUMBER' | translate }}</label
              >
              <div class="control">
                <span *ngIf="!isEditable">{{
                  form.get('streetNumber').value || '-'
                }}</span>
                <input
                  *ngIf="isEditable"
                  class="input"
                  type="text"
                  formControlName="streetNumber"
                  [ngClass]="{ 'is-danger': hasError('streetNumber') }"
                />
              </div>
              <p class="help is-danger" *ngIf="hasError('streetNumber')">
                {{ getError('streetNumber') }}
              </p>
            </div>

            <div class="field is-narrow">
              <label class="label" translationEditableDirective="COMMUNITY">{{
                'COMMUNITY' | translate
              }}</label>
              <div class="control">
                <ng-select
                  *ngIf="isEditable"
                  [items]="communities"
                  [multiple]="false"
                  formControlName="community"
                  [closeOnSelect]="true"
                  [ngClass]="{ 'is-danger': hasError('community') }"
                  bindLabel="name"
                  [typeahead]="onCommunitiesAutocomplete$"
                >
                </ng-select>
                <span *ngIf="!isEditable">{{
                  form.get('community').value
                    ? form.get('community').value.name
                    : '-'
                }}</span>
              </div>
              <p class="help is-danger" *ngIf="hasError('community')">
                {{ getError('community') }}
              </p>
            </div>

            <div class="field is-narrow">
              <label
                class="label"
                translationEditableDirective="COMMUNITY_OTHER"
                >{{ 'COMMUNITY_OTHER' | translate }}</label
              >
              <div class="control">
                <input
                  *ngIf="isEditable"
                  class="input"
                  formControlName="communityOther"
                  type="text"
                  [ngClass]="{ 'is-danger': hasError('communityOther') }"
                />
                <span *ngIf="!isEditable">{{
                  getField(['communityOther']) || '-'
                }}</span>
              </div>
              <p class="help is-danger" *ngIf="hasError('communityOther')">
                {{ getError('communityOther') }}
              </p>
            </div>
          </div>

          <div
            class="layers"
            [formGroup]="layers"
            *ngIf="activeLayers && activeLayers.length"
          >
            <h5 class="layers-title" translationEditableDirective="LAYERS">
              {{ 'LAYERS' | translate }}
            </h5>
            <div
              class="layers-row"
              formArrayName="rows"
              *ngFor="let layer of activeLayers; let i = index"
            >
              <span class="layers-row-name">{{ layer.get('name').value }}</span>
              <div [formGroupName]="i">
                <ng-select
                  *ngIf="isEditable"
                  [items]="layer.get('features').value"
                  [multiple]="false"
                  [closeOnSelect]="true"
                  bindLabel="label"
                  bindValue="id"
                  class="is-fullwidth"
                  formControlName="feature"
                >
                </ng-select>
                <span *ngIf="!isEditable">
                  {{
                    getSelectedFeatureById(
                      layer.get('feature').value,
                      layer.get('features').value
                    ) || 'None'
                  }}
                </span>
              </div>
              <div>
                <button
                  *ngIf="isEditable"
                  (click)="detect(layer.get('id').value)"
                  type="button"
                  class="button is-link is-small is-fullwidth"
                  translationEditableDirective="DETECT"
                >
                  {{ 'DETECT' | translate }}
                </button>
              </div>
            </div>

            <div *ngIf="isEditable">
              <button
                type="button"
                class="button is-link is-small ml-auto mt-3 mr-2 mb-2 is-block"
                translationEditableDirective="DETECT_ALL"
                style="padding-top: 1.5px"
                (click)="detectAll()"
              >
                {{ 'DETECT_ALL' | translate }}
              </button>
            </div>
          </div>

          <div class="field is-grouped buttons">
            <div class="control">
              <button
                *ngIf="isEditable"
                [disabled]="isLoading"
                type="submit"
                class="button is-primary"
                translationEditableDirective="SUBMIT"
              >
                {{ 'SAVE' | translate }}
              </button>

              <button
                *ngIf="!isEditable"
                [disabled]="isLoading"
                type="button"
                (click)="toggleEditable()"
                class="button is-link"
                translationEditableDirective="EDIT"
              >
                {{ 'EDIT' | translate }}
              </button>
            </div>
            <div class="control" *ngIf="isEditable">
              <button
                (click)="cancel()"
                class="button is-link is-danger"
                translationEditableDirective="CANCEL"
              >
                {{ 'CANCEL' | translate }}
              </button>
            </div>
            <div class="control">
              <button
                (click)="closeModal()"
                class="button is-link is-light"
                translationEditableDirective="CLOSE"
                type="button"
              >
                {{ 'CLOSE' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <button
    (click)="closeModal()"
    type="button"
    class="modal-close is-large"
    aria-label="close"
  ></button>
</div>
